export const environment = {
  production: true,
  version: "1.2.1",
  isDemo: false,
  testserver: "https://demo.deinezeiterfassung.app",
  sentryUrl: "https://a7113c6607b1c68ac49f18a2f9409fc8@o4506591572721664.ingest.sentry.io/4506591600640000"
};
